import React from 'react';
import styled from '@emotion/styled';

import { Blockquote } from './Blockquote';
import { QuoteImagesBlock } from './QuoteImagesBlock';

const QuoteSection = styled.section`
  padding: 140px 0;
`;

export const Quote = () => {
  return (
    <QuoteSection>
      <Blockquote />
      <QuoteImagesBlock />
    </QuoteSection>
  );
};
